import React from 'react';
import { Box, Typography } from '@mui/material';
import useSiteStats from '../hooks/useSiteStats';

/** Inner stat counters for the Join With Us photo bar. */
export default function SiteStatsItems() {
  const stats = useSiteStats();

  return stats.map((stat, i) => (
    <Box key={stat.id || i} sx={{ flex: '1 1 0', minWidth: { xs: '100%', sm: 0 }, textAlign: 'center', py: { xs: 1, sm: 0 } }}>
      <Typography
        sx={{
          fontFamily: '"Nunito", sans-serif',
          fontWeight: 900,
          fontSize: { xs: 28, sm: 34, md: 38 },
          lineHeight: '100%',
          letterSpacing: '0.01em',
          color: '#FFFFFF',
          mb: 1,
        }}
      >
        {stat.stat_value}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Caveat", cursive',
          fontWeight: 700,
          fontSize: { xs: 18, md: 22 },
          lineHeight: '100%',
          letterSpacing: '0.01em',
          color: '#FFFFFF',
        }}
      >
        {stat.stat_label}
      </Typography>
    </Box>
  ));
}
